import { render } from "./TheChangePassword.vue?vue&type=template&id=1556ec12"
import script from "./TheChangePassword.vue?vue&type=script&lang=js"
export * from "./TheChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__